import React from "react";
import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { InsightSearchIcon } from "./filterPanelIcons";

type InsightSearchFieldProps = {
  value: string;
  onChange: (value: string) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  onClear: () => void;
};

export const InsightSearchField: React.FC<InsightSearchFieldProps> = ({
  value,
  onChange,
  onKeyDown,
  onBlur,
  onClear,
}) => (
  <TextField
    size="small"
    fullWidth
    placeholder="Input insight ID, title..."
    value={value}
    onChange={(event) => onChange(event.target.value)}
    onKeyDown={onKeyDown}
    onBlur={onBlur}
    slotProps={{
      input: {
        startAdornment: (
          <InputAdornment position="start" sx={{ mr: 0 }}>
            <InsightSearchIcon sx={{ fontSize: 16, color: "#8C8C8C" }} />
          </InputAdornment>
        ),
        endAdornment: value.trim() ? (
          <InputAdornment position="end" sx={{ ml: 0 }}>
            <Box
              component="button"
              type="button"
              aria-label="Clear search"
              title="Clear"
              onMouseDown={(event: React.MouseEvent) => event.preventDefault()}
              onClick={onClear}
              sx={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 16,
                height: 16,
                p: 0,
                border: 0,
                bgcolor: "transparent",
                color: "#99A1AF",
                cursor: "pointer",
                flex: "none",
              }}
            >
              <Box
                component="svg"
                viewBox="0 0 12 12"
                width={12}
                height={12}
                aria-hidden
                sx={{ display: "block" }}
              >
                <path
                  d="M2.2 2.2L9.8 9.8M9.8 2.2L2.2 9.8"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                />
              </Box>
            </Box>
          </InputAdornment>
        ) : null,
      },
    }}
    sx={{
      "& .MuiInputBase-root": {
        height: 36,
        borderRadius: "4px",
        bgcolor: "#F2F2F2",
        px: "12px",
        gap: "8px",
      },
      "& .MuiOutlinedInput-notchedOutline": { border: "none" },
      "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
      "& .Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
      "& .MuiInputBase-input": {
        p: 0,
        fontSize: 14,
        color: "#0D0D0D",
        "&::placeholder": { color: "#99A1AF", opacity: 1 },
      },
    }}
  />
);
